const teamMembers = [
    {
      name: "Michael Rodriguez",
      position: "Founder & CEO",
      description:
        "With over 15 years of experience in immigration law, Michael founded Citizen Hub Immigration Services with a mission to provide accessible, professional immigration assistance to families seeking a better life in America.",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop&crop=face",
    },
    {
      name: "Sarah Johnson",
      position: "Operations Manager",
      description:
        "Sarah oversees our day-to-day operations and ensures that every client receives the highest level of service. Her attention to detail and customer-first approach makes her an invaluable part of our team.",
      image:
        "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=300&h=300&fit=crop&crop=face",
    },
    {
      name: "David Chen",
      position: "Senior Immigration Specialist",
      description:
        "David has been with Citizen Hub Immigration Services for over 10 years, helping thousands of families navigate the immigration process with professionalism and care. His expertise in complex cases is unmatched.",
      image:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300&h=300&fit=crop&crop=face",
    },
    {
      name: "Lisa Martinez",
      position: "Client Relations Specialist",
      description:
        "Lisa ensures that every client feels supported throughout their immigration journey with us. Her compassionate approach and extensive knowledge of the immigration process provide peace of mind to our clients.",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=300&h=300&fit=crop&crop=face",
    },
  ];
export default teamMembers;